import React from 'react';
import { Check, AlertCircle } from 'lucide-react';

const AlertModal = ({ alertModal, setAlertModal }) => {
  if (!alertModal.show) return null;

  const getHeaderClass = () => {
    switch (alertModal.type) {
      case 'success': return 'bg-gradient-to-r from-emerald-500 to-primary-500';
      case 'error': return 'bg-gradient-to-r from-red-500 to-rose-500';
      case 'warning': return 'bg-gradient-to-r from-amber-500 to-orange-500';
      default: return 'bg-gradient-to-r from-blue-500 to-indigo-500';
    }
  };

  const getButtonClass = () => {
    switch (alertModal.type) {
      case 'success': return 'bg-gradient-to-r from-emerald-500 to-primary-600 hover:from-emerald-600 hover:to-primary-700';
      case 'error': return 'bg-gradient-to-r from-red-500 to-rose-600 hover:from-red-600 hover:to-rose-700';
      case 'warning': return 'bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700';
      default: return 'bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700';
    }
  };

  const getIcon = () => {
    if (alertModal.type === 'success') {
      return <Check className="w-5 h-5 text-white" />;
    }
    return <AlertCircle className="w-5 h-5 text-white" />;
  };

  return (
    <div className="fixed inset-0 bg-black/60 dark:bg-black/70 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl dark:shadow-gray-900/20 max-w-md w-full overflow-hidden m-4 border border-gray-200 dark:border-gray-700">
        <div className={`px-6 py-4 ${getHeaderClass()}`}>
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-white/20 rounded-xl">
              {getIcon()}
            </div>
            <h3 className="text-lg font-bold text-white">{alertModal.title}</h3>
          </div>
        </div>
        <div className="p-6">
          <p className="text-sm text-gray-600 leading-relaxed">{alertModal.message}</p>
        </div>
        <div className="px-6 pb-6 flex justify-end">
          <button
            onClick={() => setAlertModal({ show: false, title: '', message: '', type: 'info' })}
            className={`px-5 py-2.5 text-sm font-medium text-white rounded-xl shadow-sm hover:shadow transition-all ${getButtonClass()}`}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
